import 'datatables.net/js/jquery.dataTables';
import 'datatables.net-bs4/js/dataTables.bootstrap4';
import 'datatables.net-buttons/js/dataTables.buttons.js';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import 'datatables.net-buttons-bs4/js/buttons.bootstrap4';
import 'datatables.net-responsive-bs4/js/responsive.bootstrap4';
import 'datatables.net-select-bs4/js/select.bootstrap4';
import 'bootstrap-datepicker';
import '../components/hs-datatables';
import 'yadcf/jquery.dataTables.yadcf';


export default {

  init() {


  },

  finalize() {

    $('#datatableEntries').on('change', function() {
      const workshop_entries = this.value;
      $('#dataTable').DataTable().page.len(workshop_entries).draw();
    });
    
    // initialization of datatables
    $.HSCore.components.HSDatatables.init('.js-datatable-workshop', {
      dom: 'lBfrtip',
      buttons: [
        {
          extend: 'csv',
          text: 'Export to CSV',
          className: 'btn btn-primary btn-sm mr-2',
          init: function(api, node, config) {
            $(node).removeClass('btn-secondary')
          }
        },
        {
          extend: 'excel',
          className: 'd-none'
        },
        {
          extend: 'pdf',
          className: 'd-none'
        },
      ],
    });


  }
};


// WEBPACK FOOTER //
// ./scripts/routes/workshop-report.js